// extracted by mini-css-extract-plugin
export default {"nodata":"NoData_nodata__r5i3X"};